/**
 * 地图操作常用错误状态码定义
 */
export enum FabricMapErrorCode {
  /**
   * 非法URL
   */
  invalidURL = 'invalidURL',
  /**
   * 非法参数
   */
  invalidParam = 'invalidParam',
  /**
   * 地图未找到
   */
  mapNotFound = 'mapNotFound',
  /**
   * 地图加载失败
   */
  mapDidFailLoading = 'mapDidFailLoading',
  /**
   * 地图定位用户失败
   */
  mapDidFailToLocateUser = 'mapDidFailToLocateUser',
  /**
   * 地图搜索类初始化失败
   */
  mapSearchAPIFailToInit = 'searchAPIFailToInit',
  /**
   * 地图搜索方法不存在
   */
  mapSearchMethodNotFound = 'mapSearchMethodNotFound',
  /**
   * 地图搜索参数不存在
   */
  mapSearchParamNotFound = 'mapSearchParamNotFound',
  /**
   * 地图搜索参数序列化出错
   */
  mapSearchParamSerializeError = 'mapSearchParamSerializeError',
}
